import { useQuery } from 'react-query';
import { QueryKey } from '../constants/queryKey';
import useApi from '../api';

const useInteractions = (scenarioId) => {
    const { getInteractions } = useApi();

    const query = useQuery([QueryKey.Interactions, scenarioId], () => getInteractions(scenarioId), {
        enabled: !!scenarioId,
        staleTime: 0,
    });

    const { data: interactions, isLoading, isError, isFetched } = query;

    return {
        interactions: interactions?.data,
        isLoading,
        isFetched,
        isError,
    };
};

export default useInteractions;
